<template>
  <div class="moderation">
    <p class="moderation__title h3">{{ title }}</p>

    <AppDescription v-bind="options" />

    <template v-if="options.photos.length > 0">
      <p class="moderation__gallery-title h4">Добавленные фотографии</p>

      <div class="gallery">
        <AppGalleryItem
          v-for="(photo, index) of options.photos"
          :key="index"
          :photo="photo"
          canOpen
          class="gallery__item"
        />
      </div>
    </template>

    <div class="btn-container">
      <BaseButton
        class="btn-container__item"
        @click="onAccept"
      >
        Подтвердить площадку
      </BaseButton>

      <BaseButton
        class="btn-container__item"
        theme="simple"
        @click="onOpenRejectModal"
      >
        Не подтверждать
      </BaseButton>
    </div>

    <AppModal ref="reject">
      <div class="modal">
        <p class="modal-title">
          <span class="modal-title__first">Причина отказа</span>
          <span class="modal-title__second">{{ title }}</span>
        </p>

        <BaseTextArea
          v-model="comment"
          class="modal__textarea"
          placeholder="Опишите причину по которой Вы не хотите подтверждать данное поле..."
        />

        <div class="btn-container">
          <BaseButton
            class="btn-container__item"
            @click="onReject"
          >
            Отправить
          </BaseButton>
          <BaseButton
            theme="simple"
            class="btn-container__item"
            @click="onCloseRejectModal"
          >
            Отмена
          </BaseButton>
        </div>
      </div>
    </AppModal>
  </div>
</template>

<script>
import AppDescription from '@/components/AppDescription'
import BaseButton from '@/components/Base/BaseButton'
import AppModal from '@/components/AppModal'
import BaseTextArea from '@/components/Base/BaseTextArea'
import AppGalleryItem from '@/components/AppGalleryItem'

export default {
  name: 'ModerationPage',
  components: {
    BaseTextArea,
    AppModal,
    BaseButton,
    AppDescription,
    AppGalleryItem
  },
  data () {
    return {
      title: '',
      options: {
        address: null,
        price: null,
        rating: null,
        telephone: null,
        coating: null,
        fieldSize: null,
        balls: null,
        showers: null,
        changingRooms: null,
        manishki: null,
        lighting: null,
        studdedCleats: null,
        paymentTransfer: null,
        current: null,
        photos: []
      },
      comment: ''
    }
  },
  async created () {
    await this.fetchModeration()
  },
  methods: {
    async fetchModeration () {
      try {
        const id = this.$route.params.id
        const { data } = await this.$api.moderation.moderation(id)

        this.title = data?.title

        this.options.address = data?.address
        this.options.price = data?.price
        this.options.rating = data?.rating
        this.options.telephone = data?.phone
        this.options.coating = data?.coating
        this.options.fieldSize = data?.fieldSize
        this.options.balls = data?.ball
        this.options.showers = data?.shower
        this.options.changingRooms = data?.changingRooms
        this.options.manishki = data?.manishki
        this.options.lighting = data?.lighting
        this.options.studdedCleats = data?.studdedCleats
        this.options.paymentTransfer = data?.paymentByTransfer
        this.options.schedule = data?.schedule
        this.options.current = data?.scheduleCurrentDayWeek
        this.options.photos = (data?.photo ?? []).map(item => item.url)
      } catch (e) {
        console.log(e)
      }
    },
    async onAccept () {
      const id = this.$route.params.id

      try {
        await this.$api.moderation.accept(id)
        window.location = '/fields/' + id
      } catch (e) {
        console.log(e)
        alert('Произошла ошибка!')
      }
    },
    async onReject () {
      const id = this.$route.params.id

      try {
        await this.$api.moderation.reject({ id, comment: this.comment })
        this.onCloseRejectModal()
        window.location = '/moderations'
      } catch (e) {
        console.log(e)
        alert('Произошла ошибка!')
      }
    },
    onOpenRejectModal () {
      this.$refs.reject.open()
    },
    onCloseRejectModal () {
      this.$refs.reject.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.moderation {
  &__title {
    margin-bottom: 32px;
  }

  &__gallery-title {
    margin: 60px 0 20px;
  }

  .gallery {
    display: flex;
    flex-wrap: wrap;

    &__item {
      width: 145px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  .btn-container {
    margin-top: 44px;

    &__item {
      height: 50px;
      padding: 0 20px;

      &:not(:last-child) {
        margin-right: 12px;
      }
    }
  }
}

.modal {
  width: 876px;

  &-title {
    &__first {
      font-size: 34px;
      font-weight: bold;
    }
    &__second {
      padding-left: 30px;
      font-size: 21px;
    }
  }

  &__textarea {
    margin-top: 20px; height: 270px;
  }

  .btn-container {
    margin-top: 30px;

    &__item {
      height: 50px;

      &:not(:last-child) {
        margin-right: 12px;
      }
    }
  }
}
</style>
